import { http, http_v2 } from '@api/client';
import { cachedApi, pickResult, pickResponse } from '@api/utils';
import { CompanyMasters } from './master-api.types';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

import {
  GroupCompanyAutoCompleteResult,
  CognitoUsersResult,
  BadgesMasterResult,
} from './master-api.types';

/**
 * The the types and services from masters API.
 */
export const getCompanyMasters = cachedApi(() =>
  http_v2.get<CompanyMasters.Api>('/company/master').pipe(
    pickResult(),
    map(data => {
      return {
        ...data,
        services: data.services.sort((x, y) => x.service.localeCompare(y.service)),
        types: data.types.filter((x,y)=> (x.type != 'OTT_CATALOG' && x.type != 'TV_CATALOG')).sort((x, y) => x.type.localeCompare(y.type)),
      };
    })
  )
);




/**
 * Gets autocomplete for company cached
 */
export const autoCompleteForGroupCompaniesCached = cachedApi(() => {
  return http.get<GroupCompanyAutoCompleteResult>(`/group-company-master`).pipe(
    pickResult(),
    map(data => {
      return data.sort((x, y) => x.localeCompare(y));
    })
  );
});

/**
 * Gets all users available in cognito
 */
export function allCognitoUsers(searchParam = null) {
  if (searchParam)
    return http.get<CognitoUsersResult>(`/cognito-users/${searchParam}`).pipe(pickResult());
  return http.get<CognitoUsersResult>(`/cognito-users`).pipe(pickResult());
}

/**
 * Gets badges master
 */
export const badgesMaster = cachedApi(() => {
  return http.get<BadgesMasterResult>(`/badges-master`).pipe(pickResponse(), pickResult());
});

export const badgeEvents = cachedApi(() => {
  return http.get<BadgesMasterResult>(`/events`).pipe(pickResponse(), pickResult());
});
/**
 * Get Deal Territory Interpretation
 */

export function dealTerritoryInterpretation(dealTerrritory: string = '') {
  return http.get(`/ml-api/deal-territory-attributes?deal_territory=${dealTerrritory}`);
}

/**
 * Get Deal Type Interpretation
 */

export function dealTypeInterpretation(dealType: string = '') {
  return http.get(`/ml-api/deal-type?deal_type=${dealType}`);
}

/**
 * Gets type interpretations
 */
export const typesInterpretation = cachedApi(() => {
  // return http.get<BadgesMasterResult>(`/badges-master`).pipe(pickResponse(), pickResult());
  return of([
    {
      vtr_id: 1,
      deal_type: 'Acquisition',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 2,
      deal_type: 'Production',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 3,
      deal_type: 'Distribution',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 4,
      deal_type: 'Acquired Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 5,
      deal_type: 'Season Renewal',
      deal_subtype_json: [
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 6,
      deal_type: 'Distribution Rights',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 7,
      deal_type: 'Commission',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 8,
      deal_type: 'Co-Production',
      deal_subtype_json: [
        { id: 42, name: 'Co-Production', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 9,
      deal_type: 'License Deal',
      deal_subtype_json: [
        { id: 45, name: 'Licensing Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 10,
      deal_type: 'Order',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 11,
      deal_type: 'Development',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 12,
      deal_type: 'Greenlight',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 13,
      deal_type: 'Part of Overall Deal',
      deal_subtype_json: [
        { id: 11, name: 'Part of Overall Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 14,
      deal_type: 'Sales Rights',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 15,
      deal_type: 'Commissioned',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 16,
      deal_type: 'Content Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 16,
      deal_type: 'Content Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 17,
      deal_type: 'Broadcast Deal',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 18,
      deal_type: 'Acquisition, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 18,
      deal_type: 'Acquisition, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 19,
      deal_type: 'Broadcast Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 20,
      deal_type: 'Adaptation',
      deal_subtype_json: [
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 21,
      deal_type: 'Part of Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 22,
      deal_type: 'Overall Deal',
      deal_subtype_json: [
        { id: 31, name: 'Overall Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 23,
      deal_type: 'Acquisition; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 23,
      deal_type: 'Acquisition; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 24,
      deal_type: 'Acquired rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 25,
      deal_type: 'Pre-Sales',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 26,
      deal_type: 'First-Look Deal',
      deal_subtype_json: [
        { id: 12, name: 'First-Look Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 27,
      deal_type: 'Content Partnership Deal',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 27,
      deal_type: 'Content Partnership Deal',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 28,
      deal_type: 'Distribution rights',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 29,
      deal_type: 'Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 29,
      deal_type: 'Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 30,
      deal_type: 'Series Order',
      deal_subtype_json: [
        { id: 21, name: 'Series Order', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 31,
      deal_type: 'Ordered',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 32,
      deal_type: 'Streaming Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 5, name: 'Streaming', aka: 'OTT' }, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 33,
      deal_type: 'Exclusive Content Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 33,
      deal_type: 'Exclusive Content Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 34,
      deal_type: 'Co-production',
      deal_subtype_json: [
        { id: 42, name: 'Co-Production', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 35,
      deal_type: 'Production Partnership',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 35,
      deal_type: 'Production Partnership',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 36,
      deal_type: 'Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 36,
      deal_type: 'Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 37,
      deal_type: 'Content Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 37,
      deal_type: 'Content Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 38,
      deal_type: 'Optioned Book Rights',
      deal_subtype_json: [
        { id: 19, name: 'Optioned Book Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 39,
      deal_type: 'Pre Sales',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 40,
      deal_type: 'Book Rights, Optioned',
      deal_subtype_json: [
        { id: 19, name: 'Optioned Book Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 41,
      deal_type: 'Pre Bought',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 42,
      deal_type: 'Adaptation, Production',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 43,
      deal_type: 'Production, Adaptation',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 44,
      deal_type: 'Original, Production',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 45,
      deal_type: 'Acquired',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 46,
      deal_type: 'Pilot Order',
      deal_subtype_json: [
        { id: 33, name: 'Pilot Order', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 47,
      deal_type: 'International Sales',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 48,
      deal_type: 'Commission, Original',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 49,
      deal_type: 'Pre Purchased',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 50,
      deal_type: 'Pre-Sale',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 51,
      deal_type: 'Licensed Rights',
      deal_subtype_json: [
        { id: 45, name: 'Licensing Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 52,
      deal_type: 'Production, Original',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 53,
      deal_type: 'Acquistion',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 54,
      deal_type: 'Part of Content Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 55,
      deal_type: 'Part of The Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 56,
      deal_type: 'Development Deal',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 57,
      deal_type: 'Acquired Distribution Rights',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 58,
      deal_type: 'Licensed',
      deal_subtype_json: [
        { id: 45, name: 'Licensing Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 59,
      deal_type: 'Orders',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 60,
      deal_type: 'Exclusive Streaming Rights, Package Deal',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 5, name: 'Streaming', aka: 'OTT' }, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 60,
      deal_type: 'Exclusive Streaming Rights, Package Deal',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 5, name: 'Streaming', aka: 'OTT' }, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 61,
      deal_type: 'SVOD Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 2, name: 'SVOD', aka: 'Subscription Video on Demand' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 62,
      deal_type: 'First Look Deal',
      deal_subtype_json: [
        { id: 12, name: 'First-Look Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 63,
      deal_type: 'Acquired Rights, Broadcast Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 64,
      deal_type: 'Order, Commission',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 65,
      deal_type: 'Format Acquisition',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 65,
      deal_type: 'Format Acquisition',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 66,
      deal_type: 'Order, Season Renewal',
      deal_subtype_json: [
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 67,
      deal_type: 'Exclusive Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 68,
      deal_type: 'Part of the Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 69,
      deal_type: 'Remake Rights',
      deal_subtype_json: [
        { id: 26, name: 'Remake Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 70,
      deal_type: 'Sales Deal',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 71,
      deal_type: 'Commission, Season Renewal',
      deal_subtype_json: [
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 72,
      deal_type: 'Straight to Series Order',
      deal_subtype_json: [
        { id: 1, name: 'Straight-to-Series Order', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 73,
      deal_type: 'Acquired Streaming Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 74,
      deal_type: 'Content Deal, Acquisition',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 75,
      deal_type: 'Digital Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 13, name: 'Digital' }, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 76,
      deal_type: 'Acquired Rights, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 76,
      deal_type: 'Acquired Rights, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 77,
      deal_type: 'Part of Content Partnership Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 78,
      deal_type: 'Part of the deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 79,
      deal_type: 'Original Production',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 80,
      deal_type: 'Rights Acquisition',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 81,
      deal_type: 'Book Adaptation',
      deal_subtype_json: [
        { id: 4, name: 'Book Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 82,
      deal_type: 'Acquired Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 82,
      deal_type: 'Acquired Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 83,
      deal_type: 'Distribution, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 83,
      deal_type: 'Distribution, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 84,
      deal_type: 'Part of Deal, Content-Sales Agreement',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 85,
      deal_type: 'Pre-Sale Deal',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 86,
      deal_type: 'Production, Season Renewal',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 87,
      deal_type: 'International Sales Rights',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 88,
      deal_type: 'International Sales Rights',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 89,
      deal_type: 'Production, Season Renewal',
      deal_subtype_json: [
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 90,
      deal_type: 'North American rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 91,
      deal_type: 'North American rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 92,
      deal_type: 'Co-Development',
      deal_subtype_json: [
        { id: 27, name: 'Co-Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 93,
      deal_type: 'Development, Adaptation',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 94,
      deal_type: 'Distribution',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 95,
      deal_type: 'License Deal; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 95,
      deal_type: 'License Deal; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 96,
      deal_type: 'Packaged Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 96,
      deal_type: 'Packaged Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 97,
      deal_type: 'Acquired Sales Rights',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 98,
      deal_type: 'Acquired Sales Rights',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 99,
      deal_type: 'Acquired Exclusive Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 100,
      deal_type: 'Acquired Rights, Acquisition',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 101,
      deal_type: 'Exclusive AVOD Streaming Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 4, name: 'AVOD', aka: 'Advertising Video on Demand' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 102,
      deal_type: 'Distribution Deal',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 103,
      deal_type: 'Part of Content Partnership Deal, First Look Show',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 104,
      deal_type: 'Part Of First Look Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        { id: 12, name: 'First-Look Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 105,
      deal_type: 'Content Partnership, Part of the deal',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 105,
      deal_type: 'Content Partnership, Part of the deal',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 106,
      deal_type: 'Exclusive Broadcast Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 107,
      deal_type: 'Non-Exclusive Digital Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 13, name: 'Digital' }, null, null, null, null],
      deal_tag_json: [{ id: 2, name: 'Non-Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 108,
      deal_type: 'International Rights',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 109,
      deal_type: 'Exclusive First-Look Deal',
      deal_subtype_json: [
        { id: 12, name: 'First-Look Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 110,
      deal_type: 'Greenlight, Original',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 111,
      deal_type: 'Greenlight, Season Renewal',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        { id: 37, name: 'Season Renewal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 112,
      deal_type: 'Exclusive Overall Deal',
      deal_subtype_json: [
        { id: 31, name: 'Overall Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 113,
      deal_type: 'Distribution; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 113,
      deal_type: 'Distribution; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 114,
      deal_type: 'Exclusive Programming Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 114,
      deal_type: 'Exclusive Programming Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 115,
      deal_type: 'Under the Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 116,
      deal_type: 'Partnership',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 116,
      deal_type: 'Partnership',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 117,
      deal_type: 'Bought, Acquisition',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 118,
      deal_type: 'Global Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 119,
      deal_type: 'Order, Adaptation',
      deal_subtype_json: [
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 120,
      deal_type: 'Production, Book Adaptation',
      deal_subtype_json: [
        { id: 4, name: 'Book Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 121,
      deal_type: 'Distribution Agreement',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 122,
      deal_type: 'Distribution, Part of Deal',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 123,
      deal_type: 'Format Deal',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 123,
      deal_type: 'Format Deal',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 124,
      deal_type: 'Greenlight, Order',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 125,
      deal_type: 'Greenlight, Ordered',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 126,
      deal_type: 'Local Version Development',
      deal_subtype_json: [
        { id: 16, name: 'Local Version Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 127,
      deal_type: 'Optioned Format',
      deal_subtype_json: [
        { id: 47, name: 'Optioned Format', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 128,
      deal_type: 'Acquired Rights; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 128,
      deal_type: 'Acquired Rights; Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 129,
      deal_type: 'Exclusive Content Partnership, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 129,
      deal_type: 'Exclusive Content Partnership, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 130,
      deal_type: 'License Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 130,
      deal_type: 'License Deal, Package Deal',
      deal_subtype_json: [
        { id: 32, name: 'Package Deal', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 131,
      deal_type: 'Part Of Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 132,
      deal_type: 'Part of the Content Partnership',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 133,
      deal_type: 'Production Deal',
      deal_subtype_json: [
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 134,
      deal_type: 'Straight-to-Series Order',
      deal_subtype_json: [
        { id: 1, name: 'Straight-to-Series Order', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 135,
      deal_type: 'Acquired Right',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 136,
      deal_type: 'Broadcast Rights, Digital Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 13, name: 'Digital' }, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 137,
      deal_type: 'Exclusive Streaming Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 5, name: 'Streaming', aka: 'OTT' }, null, null, null, null],
      deal_tag_json: [{ id: 1, name: 'Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 138,
      deal_type: 'Under Broadcast Deal',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 139,
      deal_type: 'Co-production Deal, Remake; adapt; local versions',
      deal_subtype_json: [
        { id: 42, name: 'Co-Production', badge_id: 1, badge_name: 'production' },
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        { id: 26, name: 'Remake Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 140,
      deal_type: 'Develop',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 141,
      deal_type: 'Developing',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 142,
      deal_type: 'Development, Original',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 143,
      deal_type: 'Distribution Deal, Non-Exclusive Rights',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 2, name: 'Non-Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 144,
      deal_type: 'International Distribution',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 145,
      deal_type: 'Distribution, Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 145,
      deal_type: 'Distribution, Format Rights',
      deal_subtype_json: [
        { id: 40, name: 'Format Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 146,
      deal_type: 'Greenlight, Commission',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 147,
      deal_type: 'Optioned',
      deal_subtype_json: [
        { id: 36, name: 'Optioned', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 148,
      deal_type: 'Order, Production',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 149,
      deal_type: 'Original, Order',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [{ id: 3, name: 'Original' }, null, null, null, null],
    },
    {
      vtr_id: 150,
      deal_type: 'Part of the Acquisition Deal',
      deal_subtype_json: [
        { id: 2, name: 'Part of the Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 151,
      deal_type: 'Content Partnership',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 151,
      deal_type: 'Content Partnership',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 152,
      deal_type: 'Pre-Bought',
      deal_subtype_json: [
        { id: 23, name: 'Pre-Bought', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 153,
      deal_type: 'Pre-sales',
      deal_subtype_json: [
        { id: 7, name: 'Pre-Sales', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 154,
      deal_type: 'Remake',
      deal_subtype_json: [
        { id: 26, name: 'Remake Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 155,
      deal_type: 'Remake, Production',
      deal_subtype_json: [
        { id: 26, name: 'Remake Rights', badge_id: 2, badge_name: 'acquisition' },
        { id: 15, name: 'Production Deal', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 156,
      deal_type: 'Sales',
      deal_subtype_json: [
        { id: 43, name: 'Sales Rights', badge_id: 3, badge_name: 'distribution' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 157,
      deal_type: 'Acquire Content from Distributors',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 158,
      deal_type: 'Acquired Broadcast Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 159,
      deal_type: 'Acquisitions',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 160,
      deal_type: 'Acquried Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 161,
      deal_type: 'Broadcast Deals',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [
        { id: 1, name: 'Broadcast', aka: 'Linear,TV,Television' },
        null,
        null,
        null,
        null,
      ],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 162,
      deal_type: 'Non-Exclusive Streaming Rights',
      deal_subtype_json: [
        { id: 20, name: 'Acquired Rights', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [{ id: 5, name: 'Streaming', aka: 'OTT' }, null, null, null, null],
      deal_tag_json: [{ id: 2, name: 'Non-Exclusive' }, null, null, null, null],
    },
    {
      vtr_id: 163,
      deal_type: 'Adaptation Rights',
      deal_subtype_json: [
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 164,
      deal_type: 'Collaboration',
      deal_subtype_json: [
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 164,
      deal_type: 'Collaboration',
      deal_subtype_json: [
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 165,
      deal_type: 'Commission, Adaptation',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        { id: 17, name: 'Adaptation', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 166,
      deal_type: 'Commission, Local Version Development',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        { id: 16, name: 'Local Version Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 167,
      deal_type: 'Commission, Production',
      deal_subtype_json: [
        { id: 44, name: 'Commissioned', aka: 'Ordered', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 168,
      deal_type: 'Development',
      deal_subtype_json: [
        { id: 34, name: 'Development', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 169,
      deal_type: 'Distribution Partnership',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        { id: 9, name: 'Partnership', aka: 'Collaboration', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 169,
      deal_type: 'Distribution Partnership',
      deal_subtype_json: [
        { id: 25, name: 'Distribution Rights', badge_id: 3, badge_name: 'distribution' },
        {
          id: 9,
          name: 'Partnership',
          aka: 'Collaboration',
          badge_id: 3,
          badge_name: 'distribution',
        },
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 170,
      deal_type: 'Finished Tape Deals',
      deal_subtype_json: [
        { id: 30, name: 'Finished Tape', badge_id: 2, badge_name: 'acquisition' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 171,
      deal_type: 'Greenlight, Production',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
    {
      vtr_id: 172,
      deal_type: 'Greenlit',
      deal_subtype_json: [
        { id: 29, name: 'Greenlit', badge_id: 1, badge_name: 'production' },
        null,
        null,
        null,
        null,
      ],
      deal_platform_rights_json: [null, null, null, null, null],
      deal_tag_json: [null, null, null, null, null],
    },
  ]).pipe(
    map(allRows =>
      allRows.map(eachRow => {
        eachRow['deal_platform_rights_json'] = eachRow['deal_platform_rights_json'].filter(x => x);
        eachRow['deal_subtype_json'] = eachRow['deal_subtype_json'].filter(x => x);
        eachRow['deal_tag_json'] = eachRow['deal_tag_json'].filter(x => x);
        return eachRow;
      })
    )
  );
});
